import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import App from './App'
import './index.css'
import './styles/mobile-fixes.css'

const rootElement = document.getElementById('root')!

const app = (
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
)

// The app is prerendered to static HTML for SEO (see scripts/prerender.mjs).
// We intentionally use createRoot (not hydrateRoot): the prerendered HTML is
// served to crawlers and paints instantly, then React re-renders cleanly over
// it. hydrateRoot would throw mismatch errors here because routes are code-split
// with React.lazy and pages animate with framer-motion.
ReactDOM.createRoot(rootElement).render(app)